import { TranslateService } from '@ngx-translate/core';

export class Message {
    constructor(
        private translateService: TranslateService
    ) {
    }

    public getMessage(key: string) {
        let message = '';
        this.translateService.get(key).subscribe((res: string) => {
            message = res;
        });
        return message;
    }

    public getMessage1(key: string) {
        let message = this.translateService.instant(key);
        return message;
    }

    

    public getMessageWithParam(key: string, param: any) {
        let message = '';
        this.translateService.get(key, param).subscribe((res: string) => {
            message = res;
        });
        return message;
    }
}